import type { MapDataConfig } from '@repo/types/maps/map-types';

type MiniMapConfig = Pick<MapDataConfig, 'isMiniMapMode' | 'isOverlayMiniMapMode' | 'publicSessionId' | 'sessionUuid'>;

export function getIsDedicatedMiniMap(mapConfig: MiniMapConfig | null | undefined): boolean {
    return !!mapConfig?.isOverlayMiniMapMode;
}

export function getIsConfiguredMiniMap(mapConfig: MiniMapConfig | null | undefined): boolean {
    return !!mapConfig?.isMiniMapMode || getIsDedicatedMiniMap(mapConfig);
}

export function getIsSessionMiniMap(mapConfig: MiniMapConfig | null | undefined, isMiniMapMode: boolean): boolean {
    return (
        !getIsDedicatedMiniMap(mapConfig) &&
        (isMiniMapMode || !!mapConfig?.isMiniMapMode) &&
        !!(mapConfig?.sessionUuid || mapConfig?.publicSessionId)
    );
}
